import React, { useEffect, useState } from 'react';
import { ArrowRight, Shield, Lock, CreditCard, Zap } from 'lucide-react';
import { trackInitiateCheckout } from './MetaPixel';
const CHECKOUT_URL = 'https://funcional-360.impultienda.ar/checkout';
const KIT_ITEMS = [{
  label: '12 Tomos digitales completos',
  value: 'US$ 47'
}, {
  label: '6 Bonos exclusivos',
  value: 'US$ 114'
}];
const TOTAL_VALUE = 'US$ 161';
const PRICE = 'US$ 19';
export function PricingSection() {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 37
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-153" data-mp="3c93301d3htyx">
      {/* Headline */}
      <div className="flex items-center justify-center gap-3 sm:gap-5 mb-8" data-id="element-154" data-mp="3vyx96505i8ho">
        <span className="text-4xl sm:text-5xl md:text-6xl flex-shrink-0" data-id="element-155" data-mp="4s49x6ox4jfs">
          🏆
        </span>
        <h2 className="font-serif text-3xl sm:text-5xl md:text-6xl font-bold text-stone-900 leading-[1.05] text-center" data-id="element-156" data-mp="9ta65ehseou2">
          Oferta Especial de Lanzamiento
        </h2>
      </div>

      {/* Countdown */}
      <div className="flex justify-center items-center gap-2 sm:gap-3 mb-4" data-id="element-157" data-mp="3daa43mhz5j43">
        {[timeLeft.h, timeLeft.m, timeLeft.s].map((unit, i) => <React.Fragment key={i} data-id="element-158" data-mp="3n75306i5tliw" data-mpi={i}>
            {i > 0 && <span className="font-serif text-3xl sm:text-4xl text-coral-400" data-id="element-159" data-mp="3n5kasnjbieo7">
                :
              </span>}
            <div className="bg-white border border-stone-200 rounded-2xl shadow-sm px-4 sm:px-6 py-2 sm:py-3" data-id="element-160" data-mp="3rzoduvpgq2k0">
              <span className="font-serif text-3xl sm:text-4xl font-bold text-coral-500 tabular-nums" data-id="element-161" data-mp="2zhashvlbc91t">
                {String(unit).padStart(2, '0')}
              </span>
            </div>
          </React.Fragment>)}
      </div>

      <p className="text-center text-coral-500 font-medium mb-14" data-id="element-162" data-mp="2mgqfve1kmjir">
        🔴 El precio sube cuando termina el contador
      </p>

      {/* Value-stack card */}
      <div className="relative max-w-2xl mx-auto" data-id="element-163" data-mp="2w7uxymmjmkht">
        <div className="absolute -top-5 left-1/2 -translate-x-1/2 z-10 bg-coral-500 text-white font-bold text-xs sm:text-sm tracking-widest uppercase px-7 py-3 rounded-full shadow-md whitespace-nowrap" data-id="element-164" data-mp="2w839ob6xjjrf">
          Contenido del kit:
        </div>

        <div className="bg-white rounded-[2rem] border border-stone-200 shadow-sm pt-14 px-5 sm:px-10 pb-8" data-id="element-165" data-mp="2ifwvuvr91ov5">
          {/* Line items */}
          <ul data-id="element-166" data-mp="2dgahuk3lk4la">
            {KIT_ITEMS.map(item => <li key={item.label} className="flex items-center justify-between gap-4 py-5 border-b border-stone-200" data-id="element-167" data-mp="3tv3d7zvyaxbd">
                <span className="font-bold text-stone-900 text-sm sm:text-base" data-id="element-168" data-mp="3ovz1b1hn6lhc">
                  {item.label}
                </span>
                <span className="font-bold text-coral-500 line-through text-base sm:text-lg whitespace-nowrap" data-id="element-169" data-mp="59716qltzymv">
                  {item.value}
                </span>
              </li>)}
          </ul>

          {/* Total */}
          <div className="flex items-center justify-between gap-4 pt-6" data-id="element-170" data-mp="3rhgazej9htrn">
            <span className="font-serif font-bold text-stone-900 text-lg sm:text-2xl tracking-wide" data-id="element-171" data-mp="j0d837rfwyjs">
              VALOR TOTAL:
            </span>
            <span className="font-bold text-coral-500 line-through text-lg sm:text-2xl whitespace-nowrap" data-id="element-172" data-mp="nz6hop3lw5eo">
              {TOTAL_VALUE}
            </span>
          </div>

          {/* Hero price */}
          <div className="text-center py-8" data-id="element-173" data-mp="e8bzbvthdpyi">
            <div className="flex items-center justify-center gap-2 sm:gap-4" data-id="element-174" data-mp="11z7lodf63syd">
              <span className="text-3xl sm:text-5xl flex-shrink-0" data-id="element-175" data-mp="16qft53wxt48w">🏆</span>
              <span className="font-serif font-bold text-coral-500 text-5xl sm:text-7xl leading-none whitespace-nowrap" data-id="element-176" data-mp="16sk8ci0adpoh">
                {PRICE}
              </span>
            </div>
            <p className="font-bold text-coral-400 line-through text-lg sm:text-xl mt-3" data-id="element-177" data-mp="3a6ukkwn7m5ho">
              {TOTAL_VALUE}
            </p>
          </div>

          {/* CTA */}
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout()} className="flex items-center justify-center gap-2 w-full bg-coral-500 hover:bg-coral-600 text-white font-extrabold text-base sm:text-xl text-center py-5 px-6 rounded-full shadow-lg shadow-coral-500/30 transition-colors" data-id="element-178" data-mp="318ixv5pgrrui">
            SÍ, QUIERO MI FUNCIONAL 360
            <ArrowRight className="w-5 h-5 flex-shrink-0" data-id="element-179" data-mp="3k4iq8hmcsxem" />
          </a>

          {/* Fine print */}
          <p className="text-center text-stone-500 text-xs sm:text-sm mt-6" data-id="element-180" data-mp="kky9jijwwmk8">
            Descarga inmediata · Pago único · Acceso de por vida · 7 días de
            garantía
          </p>
          <p className="text-center text-stone-400 text-xs mt-3" data-id="element-181" data-mp="1yh7z3jutfjfc">
            💱 El pago se procesará en la moneda de tu país
          </p>
        </div>
      </div>

      {/* Trust badges */}
      <div className="max-w-2xl mx-auto mt-8 grid grid-cols-2 gap-x-6 gap-y-4 text-sm text-stone-600 px-4" data-id="element-182" data-mp="27ei971vwd2io">
        <span className="flex items-center" data-id="element-183" data-mp="2cctj1cm6zd0w">
          <Lock className="w-4 h-4 mr-2 text-stone-400" data-id="element-184" data-mp="2hesp4u9bgo1j" /> Pago seguro
        </span>
        <span className="flex items-center" data-id="element-185" data-mp="2mcu9diihatel">
          <Zap className="w-4 h-4 mr-2 text-amber-500" data-id="element-186" data-mp="2mbj39c1k99kb" /> Acceso en 5 min
        </span>
        <span className="flex items-center" data-id="element-187" data-mp="2r53t2gt02x8f">
          <Shield className="w-4 h-4 mr-2 text-emerald-600" data-id="element-188" data-mp="2r66kqqy5d3pe" /> Garantía 7 días
        </span>
        <span className="flex items-center" data-id="element-189" data-mp="2v78kd8vz7hrw">
          <CreditCard className="w-4 h-4 mr-2 text-stone-400" data-id="element-190" data-mp="305a4lx551n4y" /> Tarjeta ·
          Transferencia
        </span>
      </div>
    </section>;
}
export function ComparisonTable() {
  const comparisons = [{
    without: 'Horas planificando desde cero cada semana',
    with: '5 minutos. Todo listo.'
  }, {
    without: 'Clases improvisadas sin progresión real de cargas',
    with: '+120 clases graficadas por nivel'
  }, {
    without: 'Grupos sin sistema claro de avance ni benchmarks',
    with: 'Estructura clara para cada nivel y objetivo'
  }, {
    without: 'Miedo a que un alumno se lesione por mala técnica o carga excesiva',
    with: 'Protocolo Pre-Hab y técnica corregida paso a paso'
  }, {
    without: 'Alumnos que se estancan y se van al gimnasio de enfrente',
    with: 'Progresión visible que fideliza y retiene'
  }, {
    without: 'Sin tiempo para entrenar porque planificas todo el día',
    with: 'Tus rutinas incluidas en el WOD del Profe'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-191" data-mp="3dtfpkc3a9r2">
      <h2 className="text-3xl md:text-4xl font-bold text-stone-900 text-center mb-12" data-id="element-192" data-mp="3ujulbddacb5b">
        ¿Cuánto cuesta NO tenerlo?
      </h2>

      <div className="overflow-x-auto rounded-2xl shadow-sm border border-stone-200" data-id="element-193" data-mp="2ezc477m5fnlj">
        <table className="w-full text-left border-collapse bg-white" data-id="element-194" data-mp="2f16ezt3phzbw">
          <thead data-id="element-195" data-mp="209wfrya3bu90">
            <tr data-id="element-196" data-mp="208d0a9w9dn8a">
              <th className="p-5 bg-stone-100 text-stone-600 font-bold w-1/2 border-b border-stone-200" data-id="element-197" data-mp="259ite8ttzcic">
                Sin FUNCIONAL 360
              </th>
              <th className="p-5 bg-coral-50 text-coral-600 font-bold w-1/2 border-b border-coral-100" data-id="element-198" data-mp="1r86dfxeo7awg">
                Con FUNCIONAL 360
              </th>
            </tr>
          </thead>
          <tbody data-id="element-199" data-mp="1hcv9890w1m2y">
            {comparisons.map((row, i) => <tr key={i} className="border-b border-stone-100 last:border-0" data-id="element-200" data-mp="1maekd02ahiqo" data-mpi={i}>
                <td className="p-5 text-stone-600 bg-white" data-id="element-201" data-mp="1mchkwe12iu9n">{row.without}</td>
                <td className="p-5 text-stone-900 font-medium bg-coral-50/30 flex items-start" data-id="element-202" data-mp="3bqdzqywi44er">
                  <ArrowRight className="w-5 h-5 text-coral-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-203" data-mp="3gnwc6z9q91ri" />
                  {row.with}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      <p className="text-center text-xl font-bold text-stone-900 mt-12 italic" data-id="element-204" data-mp="1zilmxbj3q0w6">
        El lunes puedes improvisar o entrar con todo resuelto. Tú decides.
      </p>
    </section>;
}